import React, { useState, createContext, useContext, useEffect, useRef } from "react";
import classes from "./ProfileComponents.module.scss";
import GeneralInfo from "./GeneralInfo";
import Details from "./Details";
import AddInfo from "./AddInfo";
import ContactInfo from "./ContactInfo";
// import ApiKeys from "./ApiKeys";
import Settings from "./Settings";
import Button from "../UI/Button";
import { useForm, FormProvider } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import axios from "axios";
import { DDD, E2Data } from "../../lib/ddd/ddd";
import { OrgIdContext } from "../../store/orgId_context";
import { Alert, LinearProgress } from "@mui/material";
import Accounts from "./Accounts";
import Files from "./Files";
import { ThreeDots } from "react-loader-spinner";
import { QueryClient } from "@tanstack/react-query";
import { useTranslation } from 'react-i18next';
import { NotificationManager} from 'react-notifications';

const apiRequestAddress = process.env.REACT_APP_API_ENDPOINT || window.location.origin + "/json.rpc";
const ddd = new DDD(apiRequestAddress);
const e2OrgData = new E2Data("EU_AOrg");
export const FormContext = createContext();

const Form = ({
  profileData,
  isEditMode,
  onEditModeHandler,
  countriesList,
  currenciesList,
  scrList,
  entityInfo,
  hideSave,
  saveRef,
  refetch,
}) => {
  // const [profileData, setprofileData] = useState({
  //   org: {
  //     Name: profileData.org.Name,
  //     Address: profileData.org.Address,
  //     PostCode: profileData.org.PostCode,
  //     CityName: profileData.org.CityName,
  //     CountryCode: profileData.org.CountryCode,
  //     TaxNum: profileData.org.TaxNum,
  //     VatNum: profileData.org.VatNum,
  //     RegNum: profileData.org.RegNum,
  //     BudgetNum: profileData.org.BudgetNum,
  //     AddInfo: profileData.org.AddInfo,
  //     ConPersonName: profileData.org.ConPersonName,
  //     ConPersonLastName: profileData.org.ConPersonLastName,
  //     ConPersonTelephone: profileData.org.ConPersonTelephone,
  //     ConPersonEmail: profileData.org.ConPersonEmail,
  //   },
  //   device: {
  //     SaleTypeDefault: profileData.device.SaleTypeDefault,
  //     PaymentTypeDefaultSC__Code: profileData.device.PaymentTypeDefaultSC__Code,
  //     APIKeyProd: profileData.device.apiKeyProd,
  //     apiKeyTest: profileData.device.apiKeyTest,
  //   },
  // });
  const [resetChildForm, setResetChildForm] = useState(false);
  const [saveError, setSaveError] = useState();
  const [saveResolve, setSaveResolve] = useState();
  const [saveReject, setSaveReject] = useState();
  const [saving, setSaving] = useState(false);
  const { mainOrgId, aboutOrgId } = useContext(OrgIdContext);
  const formRef = useRef();
  const saveResolveRef = useRef();
  const saveRejectRef = useRef();
  const { t } = useTranslation();

  const schema = yup.object().shape({
    Name: yup
      .string()
      .default(profileData.org.Name)
      .required(t("Required field!")),
    Address: yup
      .string()
      .default(profileData.org.Address)
      .required(t("Required field!")),
    PostCode: yup
      .string()
      .default(profileData.org.PostCode)
      .required(t("Required field!")),
    CityName: yup
      .string()
      .default(profileData.org.CityName)
      .required(t("Required field!")),
    CountryCode: yup
      .string()
      .default(profileData.org.CountryCode)
      .required(t("Required field!")),
    CountryCodeSC: yup
      .string()
      .default(profileData.org.CountryCodeSC),
    CounSubd: yup
      .string()
      .nullable()
      .default(profileData.org.CounSubd),
    taxNum: yup.string().transform((value, original) => (original === "" ? null : value)).required(t("Required field!")).default(profileData.org.TaxNum),
    vatNum: yup.string().nullable().transform((value, original) => (original === "" ? null : value)).default(profileData.org.VatNum),
    regNum: yup.string().nullable().transform((value, original) => (original === "" ? null : value)).label("Registration number").default(profileData.org.RegNum),
    branchNum: yup.string().nullable().transform((value, original) => (original === "" ? null : value)).label("Branch number").default(profileData.org.BranchNum),
    branchName: yup.string().nullable().transform((value, original) => (original === "" ? null : value)).label("Branch name").default(profileData.org.BranchName),
    taxOfficeId: yup.string().nullable().transform((value, original) => (original === "" ? null : value)).label("Tax office ID").default(profileData.org.TaxOfficeID),
    taxOfficeName: yup.string().nullable().transform((value, original) => (original === "" ? null : value)).label("Tax office name").default(profileData.org.TaxOfficeName),
    budgetNum: yup.string().nullable().transform((value, original) => (original === "" ? null : value)).default(profileData.org.BudgetNum),
    addInfo: yup.string().default(profileData.org.AddInfo),
    conName: yup.string().default(profileData.org.ConPersonName),
    conLastName: yup.string().default(profileData.org.ConPersonLastName),
    conPhone: yup.string().required(t("Required field!")).default(profileData.org.ConPersonTelephone),
    conEmail: yup
      .string()
      .default(profileData.org.ConPersonEmail)
      .required(t("Required field!")),
    defSaleType: yup.string().default(profileData.org.defSaleType),
    defPaymentType: yup.string().default(profileData.org.defPaymentType),
    defUnit: yup.string().default(profileData.org.defUnit),
    IBAN: yup.string().nullable().default(profileData.org.IBAN),
    BBAN: yup.string().nullable().default(profileData.org.BBAN),
    IBANBICCode: yup.string().nullable().default(profileData.org.IBANBICCode),
    BBANBICCode: yup.string().nullable().default(profileData.org.BBANBICCode),
    Logo: yup.string().nullable().default(profileData.org.Logo),
    Stamp: yup.string().nullable().default(profileData.org.Stamp),
    Web: yup.string().nullable().default(profileData.org.Web),
    WebForValidation: yup.string().nullable().default(profileData.org.WebForValidation),
    Signer: yup.string().nullable().default(profileData.org.Signer),
    SignScan: yup.string().nullable().default(profileData.org.SignScan),
    Telephone: yup.string().nullable().default(profileData.org.Telephone),
    CurrencyCode: yup.string().nullable().default(profileData.org.CurrencyCode),
    Email: yup.string().nullable().default(profileData.org.Email),
    TypePAN: yup.string().nullable().default(profileData.org.TypePAN),
    LegalStructure: yup.string().nullable().default(profileData.org.LegalStructure),
    BuildingNum: yup.string().nullable().default(profileData.org.BuildingNum),
    BuildingName: yup.string().nullable().default(profileData.org.BuildingName),
    CitySubdName: yup.string().nullable().default(profileData.org.CitySubdName),
    NameShort: yup.string().nullable().default(profileData.org.NameShort),
    IndustryCode: yup.string().nullable().default(profileData.org.IndustryCode),
    BusinessType: yup.string().nullable().default(profileData.org.BusinessType),
    CityCode: yup.string().nullable().default(profileData.org.CityCode),
    CitySubdCode: yup.string().nullable().default(profileData.org.CitySubdCode),
  });

  const values = {
    Name: profileData.org.Name,
    Address: profileData.org.Address,
    PostCode: profileData.org.PostCode,
    CityName: profileData.org.CityName,
    CountryCode: profileData.org.CountryCode,
    CountryCodeSC: profileData.org.CountryCodeSC,
    CounSubd: profileData.org.CounSubd,
    taxNum: profileData.org.TaxNum,
    vatNum: profileData.org.VatNum,
    regNum: profileData.org.RegNum,
    branchNum: profileData.org.BranchNum,
    branchName: profileData.org.BranchName,
    taxOfficeId: profileData.org.TaxOfficeID,
    taxOfficeName: profileData.org.TaxOfficeName,
    budgetNum: profileData.org.BudgetNum,
    addInfo: profileData.org.AddInfo,
    conName: profileData.org.ConPersonName,
    conLastName: profileData.org.ConPersonLastName,
    conPhone: profileData.org.ConPersonTelephone,
    conEmail: profileData.org.ConPersonEmail,
    //defSaleType: profileData.device.SaleTypeDefault,
    //defPaymentType: profileData.device.PaymentTypeDefaultSC__Code,
    defUnit: profileData.org.defUnit,
    //defMode: profileData.device.Mode,
    certificate: profileData.org.Certificate,
    certificatePass: profileData.org.CertificatePass,
    apiKeyProd: profileData.org.APIKeyProd,
    IBAN: profileData.org.IBAN,
    BBAN: profileData.org.BBAN,
    IBANBICCode: profileData.org.IBANBICCode,
    BBANBICCode: profileData.org.BBANBICCode,
    Logo: profileData.org.Logo,
    Stamp: profileData.org.Stamp,
    Web: profileData.org.Web,
    WebForValidation: profileData.org.WebForValidation,
    Signer: profileData.org.Signer,
    SignScan: profileData.org.SignScan,
    Telephone: profileData.org.Telephone,
    CurrencyCode: profileData.org.CurrencyCode,
    Email: profileData.org.Email,
    TypePAN: profileData.org.TypePAN,
    LegalStructure: profileData.org.LegalStructure,
    BuildingNum: profileData.org.BuildingNum,
    BuildingName: profileData.org.BuildingName,
    CitySubdName: profileData.org.CitySubdName,
    NameShort: profileData.org.NameShort,
    IndustryCode: profileData.org.IndustryCode,
    BusinessType: profileData.org.BusinessType,
    CityCode: profileData.org.CityCode,
    CitySubdCode: profileData.org.CitySubdCode,
  };
  // console.log(values);

  const methods = useForm({
    resolver: yupResolver(schema),
    defaultValues: values,
  });
  const { handleSubmit } = methods;
  // const [isSubmitted, setIsSubmitted] = useState(false);

  // const onFormSubmitHandler = (data) => {
  //   console.log("Submitted data: ", data);
  //   setIsSubmitted(true);
  //   onEditModeHandler(false);
  //   // axios - extension to write the data in the server
  //   // .then(() => setIsSubmitted(false)) -> in order to be able to edit again
  // };

  const onSubmit = (data) => {
    onEditModeHandler(false);
    setSaving(true);

    let newData = {};
    newData.Name = data.Name;
    newData.Address = data.Address;
    newData.PostCode = data.PostCode;
    newData.CityName = data.CityName;
    newData.CountryCode = data.CountryCode;
    newData.CountryCodeSC = data.CountryCodeSC;
    newData.CounSubd = data.CounSubd;
    newData.TaxNum = data.taxNum;
    newData.VatNum = data.vatNum;
    newData.RegNum = data.regNum;
    newData.BranchNum = data.branchNum;
    newData.BranchName = data.branchName;
    newData.TaxOfficeID = data.taxOfficeId;
    newData.TaxOfficeName = data.taxOfficeName;
    newData.BudgetNum = data.budgetNum;
    newData.AddInfo = data.addInfo;
    newData.ConPersonName = data.conName;
    newData.ConPersonLastName = data.conLastName;
    newData.ConPersonTelephone = data.conPhone;
    newData.ConPersonEmail = data.conEmail;
    newData.IBAN = data.IBAN;
    newData.BBAN = data.BBAN;
    newData.IBANBICCode = data.IBANBICCode;
    newData.BBANBICCode = data.BBANBICCode;
    newData.Logo = data.Logo;
    newData.Stamp = data.Stamp;
    newData.Web = data.Web;
    newData.Signer = data.Signer;
    newData.SignScan = data.SignScan;
    newData.Telephone = data.Telephone;
    newData.CurrencyCode = data.CurrencyCode;
    newData.Email = data.Email;
    newData.TypePAN = data.TypePAN;
    newData.LegalStructure = data.LegalStructure;
    newData.BuildingNum = data.BuildingNum;
    newData.BuildingName = data.BuildingName;
    newData.CitySubdName = data.CitySubdName;
    newData.WebForValidation = data.WebForValidation;
    newData.NameShort = data.NameShort;
    newData.IndustryCode = data.IndustryCode;
    newData.BusinessType = data.BusinessType;
    newData.CityCode = data.CityCode;
    newData.CitySubdCode = data.CitySubdCode;


    const e2data = new E2Data("EU_AOrg");
    e2data.filter = `Id="${aboutOrgId}"`;
    e2data.values = newData
    e2data.Modify().then((res)=>{
      setSaving(false);
      ddd.InvalidateSessionExtensions();
      onEditModeHandler(true);
      resetProfileCache();

      if(res?.result?.status !== "ok"){
        if(saveRejectRef.current)
          saveRejectRef.current(t("An unknown error occured. Please contact administrator."));
        setSaveError(t("An unknown error occured. Please contact administrator."));
        setTimeout(() => {
          setSaveError(null);
        }, 6000);
      }else{
        if(saveResolveRef.current){
          saveResolveRef.current();
        }else{
          NotificationManager.success("", t("Saved!"));
        }
      }
    });
  };

  const resetProfileCache = () =>{
    if(refetch)
    refetch();
    //const queryClient = new QueryClient();
    //queryClient.removeQueries(['Data.GetEntityData', e2OrgData.GetParamsObject()]);
    //queryClient.removeQueries();
  }

  const onCancelClickHandler = () => {
    //onEditModeHandler(false);
    setResetChildForm(true);
  };

  const handleChildFormReset = () => {
    setResetChildForm(false);
  };

  const manualSave = () => {
    return new Promise((resolve,reject) => {
      console.log("manual save");
      saveResolveRef.current = resolve;
      saveRejectRef.current = reject;
      formRef.current.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }))
    })
  }

  useEffect(() => {
    if(!saveRef) return;
    saveRef({manualSave})
  }, [saveRef])

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(onSubmit)} ref={formRef}>
        <GeneralInfo
          isEditMode={isEditMode}
          onFormReset={handleChildFormReset}
          shouldReset={resetChildForm}
          countriesList={countriesList}
          scrList={scrList}
          profileData={profileData}
        />
        <Details
          isEditMode={isEditMode}
          onFormReset={handleChildFormReset}
          shouldReset={resetChildForm}
        />
        <ContactInfo
          isEditMode={isEditMode}
          onFormReset={handleChildFormReset}
          shouldReset={resetChildForm}
        />
        <Accounts
          isEditMode={isEditMode}
          onFormReset={handleChildFormReset}
          shouldReset={resetChildForm}
        />
        <Files
          isEditMode={isEditMode}
          currenciesList={currenciesList}
          onFormReset={handleChildFormReset}
          shouldReset={resetChildForm}
          entityInfo={entityInfo}
          profileData={profileData}
        />
        {/* <ApiKeys
          isEditMode={isEditMode}
          onFormReset={handleChildFormReset}
          shouldReset={resetChildForm}
          certificateId={
            profileData.org.Certificate
            // && profileData.org.Certificate.split("/")[1]
          }
        /> */}
        {/* <Settings
          defSaleType={values.defSaleType}
          defPaymentType={values.defPaymentType}
          isEditMode={isEditMode}
          onFormReset={handleChildFormReset}
          shouldReset={resetChildForm}
        /> */}
        <AddInfo
          isEditMode={isEditMode}
          onFormReset={handleChildFormReset}
          shouldReset={resetChildForm}
        />
        {saveError && <Alert severity="error">{saveError}</Alert>}
        {!hideSave && (
          <div className={`mt-4 ${classes["edit-btns-container"]}`}> 
            {/* <Button
              className={`px-5 py-1 ${classes["edit-button"]}`}
              onClick={onCancelClickHandler}
            >
              Cancel
            </Button> */}
            <Button type="submit" className="px-5 py-1 ms-3">
              {t("Save")}
              {saving && <LinearProgress/>}
            </Button>
            
          </div>
        )}
      </form>
    </FormProvider>
  );
};

export default Form;
